import { createClient } from "../generated/auth/client/client.gen";

import type { Client } from "../generated/auth/client/types.gen";

/**
 * A client with its own axios instance. App instances attach the session's token to every
 * request, so refreshing that session through one would need a token to get a token.
 */
export const createAuthHeyClient = (baseURL: string): Client =>
  createClient({ baseURL });
